import { Space } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { type } from '../../utilities/constants';
import TableWithSorter from '../Common/TableWithSorter';

function CreatorTable(props) {
  const data = props.data;
  const columns = [
    {
      title: 'university',
      dataIndex: 'university',
      key: 'university',
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/creator/' + record.university}>{record.university}</Link>
        </Space>
      ),
      type: type.NUMBER,
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
  ];
  return (
    <>
      <TableWithSorter
        tableLayout="auto"
        scroll={{ x: 1000 }}
        expandable={{ defaultExpandAllRows: true }}
        loading={props.loading}
        dataSource={data}
        columns={columns}
        pagination={{
          total: props.totalCount,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
        }}
        onChange={props.onPaginationChange}
      />
    </>
  );
}

export default CreatorTable;
